import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ApplicationUser,
  DefaultResponse,
  PaginationForm,
  UserPaged,
} from '../../models';
import { GroupList } from '../../models/group.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly API = `${environment.api_url}/Usuario`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<ApplicationUser[]> {
    return this.http.get<ApplicationUser[]>(this.API);
  }

   getAllUsersFiltered(filter: Partial<PaginationForm> = null): Observable<UserPaged> {
    return this.http.get<UserPaged>(`${this.API}/GetUsuariosFiltered`, {
      params: filter
    });
  }

  insertUser(user: ApplicationUser): Observable<ApplicationUser> {
    return this.http.post<ApplicationUser>(this.API, user);
  }

  updateUser(user: ApplicationUser): Observable<ApplicationUser> {
    return this.http.put<ApplicationUser>(`${this.API}/Usuario`, user);
  }

  getUserById(id: number): Observable<ApplicationUser> {
    return this.http.get<ApplicationUser>(`${this.API}/${id}`);
  }

  updatePassword(senha: string, token: string): Observable<void> {
    return this.http.put<void>(`${this.API}/UpdatePassword`, {
      token: token,
      password: senha,
      rePassword: senha,
    });
  }

  getGroupList(): Observable<DefaultResponse<GroupList>> {
    return this.http.get<DefaultResponse<GroupList>>(
      `${this.API}/GetAllGrupos`
    );
  }

  disableUser(id: number): Observable<void> {
    return this.http.patch<void>(`${this.API}/bloquear/${id}`, '');
  }
}
